// src/pages/Admissions.js
// ──────────────────────────────────────────────────────────────────────────
// Lightweight placeholder so every "Apply" CTA resolves. Expand this into a
// full admissions page (requirements, deadlines, fees, application form) —
// you can reuse your existing ContactAPI.submit for the enquiry form.
// ──────────────────────────────────────────────────────────────────────────

import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useSiteContent } from '../context/SiteContentContext';
import theme from '../theme/theme';

const Wrap = styled.section`
  max-width: 720px;
  margin: 0 auto;
  padding: 5rem ${theme.layout.gutter} 6rem;
  h1 { font-size: clamp(2.4rem, 6vw, 3.6rem); margin-bottom: 1rem; }
  p  { color: ${theme.color.inkSoft}; margin-bottom: 1rem; }
`;

const Note = styled.div`
  margin-top: 2rem;
  padding: 1.2rem 1.4rem;
  border-left: 3px solid ${theme.color.accent};
  background: ${theme.color.paperAlt};
  font-size: 0.95rem;
`;

const Back = styled(Link)`
  display: inline-block;
  margin-top: 2rem;
  color: ${theme.color.accent};
  font-weight: 600;
`;

function Admissions() {
  const a = useSiteContent('admissions');
  return (
    <>
      <Navbar />
      <Wrap>
        <h1>{a?.title || 'Admissions'}</h1>
        <p>{a?.body || 'Applications for the next intake are open.'}</p>
        <Note><strong>{a?.deadline || 'Applications close 30 September'}</strong></Note>
        <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <Link to="/apply" style={{ background: theme.color.accent, color: theme.color.onAccent, fontWeight: 700, padding: '13px 26px', borderRadius: theme.layout.radius }}>Apply now →</Link>
          <Back to="/programs" style={{ marginTop: 0, alignSelf: 'center' }}>Browse programmes first</Back>
        </div>
      </Wrap>
      <Footer />
    </>
  );
}

export default Admissions;
